import { createFetcher } from '../../Common';

import { queryBuilder } from '../../utils';

import { CONFIG_ENDPOINT, getBaseUrl } from '../../constants';

export class Config {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Config(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.endpoint = CONFIG_ENDPOINT;
    this.fetcher = fetcher;
  }

  get base_url() {
    return getBaseUrl();
  }

  async getAllConfig(req) {
    const queryString = queryBuilder(req);
    const url = `${this.base_url}${this.endpoint}${queryString}`;
    const response = await this.fetcher.getData(url);
    return response?.data;
  }

  async putConfig(reqBody) {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.putData(url, reqBody);
    return response?.data;
  }

  async postConfig(reqBody) {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.postData(url, reqBody);
    return response?.data;
  }
}

export const createConfig = () => Config.getInstance();
